<template>
    <section class="video-embed light purple">
        <circles-layout></circles-layout>
        <ogt-video ref="video" src="/static/video/ontwikkeling.mp4" :muted="false"></ogt-video>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import OgtVideo from '@/app/components/OgtVideo';
    import Circles from '@/app/components/circles';
    export default {
        name: 'OntwikkelingIntroVideo',
        meta: {
            title: 'OntwikkelingIntroVideo',
            color: '#a5147e'
        },
        components: {
            'ogt-video': OgtVideo,
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            }
        }
    };
</script>
